// extracted by mini-css-extract-plugin
export default {"movieCard":"MovieCard_movieCard__uD97G","movieImage":"MovieCard_movieImage__XoYcn"};